import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { FatturaAdapter } from '../components/fascicolo/fatture-edit/fattura-adapter';
import { AltraParte } from '../models/altraparte';
import { AttivitaFattura } from '../models/attivita-fatture';
import { SezioneAltrePartiResponse } from '../models/dto/sezione-altre-parti-response';
import { Fattura } from '../models/fattura';
import { SezioneAltreParti } from '../models/sezioni/sezione-altre-parti';
import { Categoria } from '../models/tipologiche/categoria';
import { Iva } from '../models/tipologiche/iva';
import { TipoFase } from '../models/tipologiche/tipo-fase';
import { FormValidationService } from '../services/form-validation.service';
import { BaseForm } from './base-Form';
import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'div [fattura-form]',
  templateUrl: 'fattura-form.html'
})

export abstract class FatturaForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  request: Fattura;
  fatturaForm: FormGroup;
  attFatturaForm: FormGroup;
  msgNoBeneficiari: string;

  // options
  categorie: Categoria[] = [];
  ivaOptions: Iva[] = [] ;
  altrePartiOptions: AltraParte[] = [] ;
  altrePartiAll: AltraParte[] = [];
  tipoFaseOptions: TipoFase[] = [] ;
  newAttivitaFattura: AttivitaFattura;
  IdTipoFase: string;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;
  visibleToggleRiepilogo: boolean = false;

  // abstract
  abstract getFattura(): Fattura;
  abstract getRequest(request: Fattura);
  abstract getUrlReadSezioneAltreParti(): string;

  @ViewChild('searchItem') searchItemRef!: ElementRef;

  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private formValidationService: FormValidationService) {
                super();
  }

 initRequest() {
    this.request = new FatturaAdapter(this.getFattura()).fattura;
    this.ricalcolaImporti();
    this.initViewToggle();
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.visibleToggleRiepilogo = false;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
      this.initRequest();
      this.fatturaForm = this.campiForm.group({
      id: [this.request.id],
      altraParte: [this.request.altraParte],
      dataEmissione: [this.request.dataEmissione, Validators.required],
      numeroFattura: [this.request.numeroFattura, Validators.required],
      numeroGiorniPagamento: [this.request.numeroGiorniPagamento],
      totaleImportoAttivita: [this.request.totaleImportoAttivita],
      speseEsenti: [this.request.speseEsenti],
      speseImponibili: [this.request.speseImponibili],
      iva: [this.request.iva],
      flagIva: [this.request.flagIva],
      flagContributoPrevidenziale: [this.request.flagContributoPrevidenziale],
      descrizioneContributoPrevidenziale: [this.request.descrizioneContributoPrevidenziale],
      percentualeContributoPrevidenziale: [this.request.percentualeContributoPrevidenziale],
      flagAltreSpese: [this.request.flagAltreSpese],
      descrizioneAltreSpese: [this.request.descrizioneAltreSpese],
      percentualeAltreSpese: [this.request.percentualeAltreSpese],
      flagRitenutaAcconto: [this.request.flagRitenutaAcconto],
      attivitaFatture: [this.request.attivitaFatture],
      note: [this.request.note],
      documenti: [this.request.documenti],
    });

      this.newAttivitaFattura = new AttivitaFattura;
      this.attFatturaForm = this.campiForm.group({
      attivita: [this.newAttivitaFattura.attivita, Validators.required],
      codice: [this.newAttivitaFattura.codice,  Validators.compose([this.formValidationService.numeri])],
      importo: [this.newAttivitaFattura.importo, Validators.required],
      tipoFase: [this.newAttivitaFattura.tipoFase, Validators.required],
    });
  }

  public setTextEmpty() {
    this.searchItemRef.nativeElement.value = '';
  }

  populateSelect() {
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.tipoFaseOptions.length === 0) {
      this.helpers.getTipiFase().subscribe(response => this.tipoFaseOptions = response);
    }
    if (this.categorie.length === 0) {
      this.helpers.getCategorieAltraParte().subscribe(response => this.categorie = response);
    }
  }

  save() {
    this.getRequest(this.request);
  }

  readSezioneAltreParti(idSezioneAltreParti: string) {
    this.operationService.readSezione(this.getUrlReadSezioneAltreParti(), idSezioneAltreParti)
      .subscribe(response => this.readSezioneAltrePartiResponse((<SezioneAltrePartiResponse>response).sezione));
  }

  readSezioneAltrePartiResponse(sezioneAltreParti: SezioneAltreParti) {
    this.altrePartiAll = sezioneAltreParti.altreParti;
    this.altrePartiAll = this.altrePartiAll.filter(ap => { return ap.ritirato === false; });
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
    this.reviewLabelAltreParti();
    if (this.getFattura() && !this.inserimento && this.getFattura().altraParte.categoriaAltraParte) {
      this.altrePartiOptions = this.altrePartiAll.filter(altraParte => { return altraParte.categoriaAltraParte.id === this.getFattura().altraParte.categoriaAltraParte.id; });
    }
  }

  populateBeneficiari(event: any) {
    if (event.target.value && this.altrePartiAll.length > 0) {
      this.altrePartiOptions = this.altrePartiAll.filter(altraParte => { return altraParte.categoriaAltraParte.label === event.target.value; });
      this.reviewLabelAltreParti();
    }
  }

  reviewLabelAltreParti() {
    for (let altraparte of this.altrePartiAll) {
        altraparte.parte.nominativo = this.getBeneficiarioLabel(altraparte);
    }
  }

  goToAssocia() {
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  goToForm() {
    this.visibleToggleRiepilogo = false;
    this.visibleToggleForm = true;
  }

  associaBeneficiario(altraParte: AltraParte) {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.getAltraParte(altraParte);
  }

  calcolaFattura(altraParte: AltraParte) {
    this.visibleToggleRiepilogo = true;
    this.visibleToggleForm = false;
    this.getAltraParte(altraParte);
  }

  getAltraParte(altraParte: AltraParte) {
    if (altraParte.id) {
      this.request.altraParte = this.altrePartiAll.filter((a: AltraParte) => a.id === altraParte.id)[0];
    }
  }

  addAttFattura(newAttivitaFattura: AttivitaFattura) {
    let tipoFase: TipoFase = new TipoFase;
    if (this.IdTipoFase) {
      tipoFase = this.tipoFaseOptions.filter(tipoFaseEl => { return tipoFaseEl.id === this.IdTipoFase; })[0];
    }
    newAttivitaFattura.tipoFase = new TipoFase();
    newAttivitaFattura.tipoFase = tipoFase;
    this.request.attivitaFatture.push(newAttivitaFattura);
    this.ricalcolaImporti();
    this.newAttivitaFattura = new AttivitaFattura;
    this.IdTipoFase = null;
  }

  removeAttFattura(index: number) {
    this.request.attivitaFatture.splice(index, 1);
    this.ricalcolaImporti();
  }

  changeIdTipoFase(event: any) {
    this.IdTipoFase = event.target.value;
  }

  ricalcolaImporti() {
    let result = 0;
    if (this.request.attivitaFatture) {
      for (let attFattura of this.request.attivitaFatture) {
          result = result + Number(attFattura.importo ? attFattura.importo : 0);
      }
    }
    this.request.totaleImportoAttivita = result;
  }

  getBeneficiarioLabel(altraParte: AltraParte): string {
    let result = '';
    if (altraParte && altraParte.parte && altraParte.parte.tipoPersona) {
      if (altraParte.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = altraParte.parte.cognome + ' ' + altraParte.parte.nome;
      }
      if (altraParte.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = altraParte.parte.ragioneSociale;
      }
    }
    return result;
  }

}
